import { HTTP } from '../../utils'

export const getAllToolsForInstitution = () => {
  return HTTP().get('tool/findByOwningInstitution?page=0&count=999')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const createOrUpdateTool = (tool) => {
  var url = 'tool/'
  if (tool.uuid) {
    url += tool.uuid
  }
  return HTTP().put(url, tool)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
    return e.response
  })
}

export const getToolDetail = (uuid) => {
  return HTTP().get('tool/' + uuid)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const deleteMultipleTool = (uuids) => {
  return HTTP().delete('tool/multiple?uuids=' + uuids)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const getToolProxies = (uuid) => {
  return HTTP().get('toolProxy/toolInCourse/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const crateOrUpdateToolProxy = (data) => {
  var url = 'toolProxy/'
  if (data.uuid) {
    url += data.uuid
  }
  return HTTP().put(url, data)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
    return e.response
  })
}

export const deleteToolProxy = (uuid) => {
  return HTTP().delete('toolProxy/' + uuid)
  .then(res => {
    return res
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/tool/api.js